"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAudioIntensityHandler = getAudioIntensityHandler;
/**
 * @param {*} dispatch
 * @param {*} actions
 * @returns
 */

function getAudioIntensityHandler(dispatch, actions) {
  return function audioIntensityHandler(audioIntensityScore) {
    var setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
    dispatch(setAttendeeVoiceIntensity(audioIntensityScore));
  };
}